import BaseFormPage from "../../../base/BaseFormPage.js";
import {
  deleteObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object/index.js";
import withRouter from "../../../withRouter.js";
import EmployeesFormPagePresenter from "./EmployeesFormPagePresenter.js";
import DialogSuccess from "../../../components/DialogSuccess/index.js";
import dialog from "../../../components/Modal/dialog.js";
import FullPageLoader from "../../../components/FullPageLoader/index.js";
import SuppliersForm from "./components/SuppliersForm.js/SupplierForm.js";
import DiscardDialog from "../../../components/DiscardDialog/index.js";
import FormFactory from "../../../components/FormFactory/index.js";
import PageHeader from "../../../components/PageHeader/index.js";
import { Button, InfiniteScroll } from "../../../nq-component";

class EmployeesFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
    };
    this.presenter = new EmployeesFormPagePresenter(
      this,
      getObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
    );
  }

  getCollectionName() {
    return "employees";
  }

  getProvinces(region) {
    this.presenter.getAllProvinces(region);
  }

  getClientId() {
    return this.props.params.clientId;
  }

  onClose() {
    dialog.close();
  }

  successModal(message) {
    dialog.fire({
      html: <DialogSuccess message={message} />,
      footer: false,
    });
  }

  onDiscardConfirm() {
    dialog.close();
    this.navigateBack();
  }

  discardModal() {
    dialog.fire({
      html: <DiscardDialog onConfirm={this.onDiscardConfirm.bind(this)} />,
      footer: false,
    });
  }

  render() {
    const { progress, object } = this.state;
    const user = this.getCurrentUser();
    const schema = this.getSchema(this.getCollectionName());
    const schemas = this.getSchemas();
    const title = object?.id ? "Edit Employee" : "Add Employee";
    return (
      <>
        <InfiniteScroll className={"overflow-auto"}>
          <div className="p-3 p-xl-4 d-flex flex-column gap-4">
            {/* Header Section */}
            <PageHeader
              breadcrumb={[
                { label: "Home", path: "/" },
                { label: "Employees", path: "/employees" },
                { label: object?.id ? "Edit Employee" : "Add Employee" },
              ]}
              title={title}
              backButton
              description={"Enter Employee information"}
            />

            {/* Form Card */}
            <form
              className="bg-white rounded-3 d-flex flex-column shadow-sm p-2 p-md-3 p-lg-4 gap-2"
              style={{
                border: "1px solid #e9ecef",
              }}
              onSubmit={this.onSubmitForm.bind(this)}
            >
              <FormFactory
                schema={schema}
                schemas={schemas}
                onChange={this.onChange.bind(this)}
                object={object}
              />

              <div className="d-flex gap-2 mt-2">
                <button
                  type="button"
                  className="btn btn-light fw-medium border flex-fill"
                  onClick={this.onClickBack.bind(this)}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn btn-primary fw-medium flex-fill"
                  disabled={!this.hasActualChanges()}
                >
                  <i className="bi bi-check-lg fw-bold"></i> Submit
                </button>
              </div>
            </form>
            {progress ? <FullPageLoader /> : ""}
          </div>
        </InfiniteScroll>
        {this.renderPreviewModal()}
      </>
    );
  }
}

export default withRouter(EmployeesFormPage);
